//Video Events
export const M_VIDEO_START = 'M_Video_Start'
export const M_VIDEO_PAN = 'M_Video_Pan'
export const M_VIDEO_QUALITYCHANGE = 'M_Video_QualityChange'
export const M_VIDEO_UNMUTE = 'M_Video_Unmute'
export const M_VIDEO_MUTE = 'M_Video_Mute'
export const M_INTROVIDEO_SKIPPED = 'M_IntroVideo_Skipped'
export const M_VIDEO_SEEK = 'M_Video_Seek'

//Pano Events
export const M_PANO_PAN = 'M_Pano_Pan'
export const M_PANO_TAP = 'M_Pano_Tap'

//Menu Events
export const M_MENU_TAPPED = 'M_Menu_Tapped'
export const M_MENU_SHARE_TAPPED = 'M_Menu_Share_Tapped'
export const M_MENU_EMAIL = 'M_Menu_Email'
export const M_MENU_LINK = 'M_Menu_Link'
export const M_MENU_TWITTER = 'M_Menu_Twitter'
export const M_MENU_LINKEDIN = 'M_Menu_Linkedin'
export const M_MENU_FACEBOOK = 'M_Menu_Facebook'
export const M_SLIDEOUT_VRBUTTON_TAPPED = 'M_Slideout_VRButton_Tapped'

// Main Screen Buttons
export const M_VRBUTTON_TAPPED = 'M_VRButton_Tapped'
export const M_CTABUTTON_TAPPED = 'M_CTAButton_Tapped'
export const M_LOC_DROPDOWN_TAPPED = 'M_LocationsDropdown_Tapped'
export const M_LOC_DROPDOWN_LOCTAPPED = 'M_LocationsDropdown_LocationsTapped'

//Triggers
export const M_TRIGGER_POPUP_LAUNCHED = 'M_Trigger_Popup_Launched'
export const M_TRIGGER_POPUP_ENTER_TAPPED = 'M_Trigger_Popup_Enter_Tapped'
export const M_TRIGGER_VIDEO_STARTED = 'M_Trigger_Video_Started'
export const M_TRIGGER_VIDEO_PAN = 'M_Trigger_Video_Pan'

//Hotspots
export const M_HOTSPOT_TAPPED = 'M_Hotspot_Tapped'
export const M_HOTSPOT_VIDEO_VIEWED = 'M_Hotspot_Video_Viewed'
export const M_HOTSPOT_VIDEODESC_COMPLETED = 'M_Hotspot_VideoDescription_Completed'
export const M_HOTSPOT_PANO_VIEWED = 'M_Hotspot_Pano_Viewed'
export const M_HOTSPOT_IMAGE_VIEWED = 'M_Hotspot_Image_Viewed'
export const M_HOTSPOT_IMAGEDESC_COMPLETED = 'M_Hotspot_ImageDescription_Completed'
export const M_HOTSPOT_TEXT_COMPLETED = 'M_Hotspot_Text_Completed'

// Stops/StopCards
export const M_SCENE_ENTER = 'M_Scene_Enter'
export const M_SCENE_10SECONDS = 'M_Scene_10seconds'
export const M_STOPCARDS_STOPLIST_TAPPED = 'M_StopCards_StopList_tapped'
export const M_SCENENAV_STOPLIST_TAPPED = 'M_SceneNav_StopList_tapped'
export const M_SCENE_MOREINFO_SWIPE = 'M_Scene_MoreInfo_Swipe'
export const M_STOPCARDS_TAPPED = 'M_StopCards_Tapped'
export const M_STOPCARDS_SHARE_TAPPED = 'M_StopCards_Share_Tapped'
export const M_STOPCARDS_MOREINFO_COMPLETED = 'M_StopCards_MoreInfo_Completed' //<- this info is on stopcards on mobile
export const M_STOPCARDS_LANGUAGE_CHANGED = 'M_StopCards_Language_Changed'
export const M_STOPCARDS_SUPPMEDIA_SWIPE = 'M_StopCards_SuppMedia_Swipe'

// Guide/Info
export const M_TOURGUIDE_ON = 'M_TourGuide_On'
export const M_TOURGUIDE_OFF = 'M_TourGuide_Off'
export const M_TOURGUIDE_CHANGELANGUAGE = 'M_TourGuide_ChangeLanguage'

// Walking
export const M_SCENE_NEXTARROW_TAPPED = 'M_Scene_NextArrow_tapped'
export const M_SCENE_BACKARROW_TAPPED = 'M_Scene_BackArrow_tapped'

//Supplemental Media
export const M_SUPPMEDIA_TAPPED = 'M_SuppMedia_Tapped'
export const M_SUPPMEDIA_BOX_TAPPED = 'M_SuppMedia_Box_Tapped'
export const M_SUPPMEDIA_CATEGORY_TAPPED = 'M_SuppMedia_Category_Tapped'
export const M_SUPPMEDIA_VIDEO_INFO_TAPPED = 'M_SuppMedia_Video_Info_Tapped'
export const M_SUPPMEDIA_VIDEO_EXPAND = 'M_SuppMedia_Video_Expand'
export const M_SUPPMEDIA_PHOTO_INFO_TAPPED = 'M_SuppMedia_Photo_Info_Tapped'
export const M_SUPPMEDIA_PANO_INFO_TAPPED = 'M_SuppMedia_Pano_Info_Tapped'

//Map
export const M_MAP_ZOOM_IN = 'M_Map_Zoom_In'
export const M_MAP_ZOOM_OUT = 'M_Map_Zoom_Out'
export const M_MAP_STOP_TAPPED = 'M_Map_Stop_tapped'
export const M_MAP_SUPPMEDIA_TAPPED = 'M_Map_SuppMedia_Tapped'
export const M_MAP_SUPPMEDIA_VIEWED = 'M_Map_SuppMedia_Viewed'

//Registration
export const M_REGISTRATIONBUTTON_TAPPED = 'M_RegistrationButton_Tapped'
export const M_REGISTRATIONSUBMITTED = 'M_RegistrationSubmitted'
